/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import {
  browserName,
  browserVersion,
  osVersion,
  osName,
} from 'react-device-detect';
import { useMutation, useQuery } from 'react-query';
import StyledPage from './StyledPage';
import api from '../../../api';
import Loader from '../../Loader';
import Logo from '../../../assets/images/Logo.png';

// Game results chart/table removed for participant flow (no results shown).

// GameResultsChart / ExpandableResults removed for participant flow.

const GameEnd = ({
  gameConfig, resetTest, results, practiceData,
}) => {
  const [saveResults, saveResult] = useMutation(api.game.saveGameResults);
  const passedGamesCount = useQuery('passedGamesCount', api.game.getPassedGamesCount);
  const [deviceInfo, setDeviceInfo] = useState(null);
  const [saved, setSaved] = useState(false);
  const [finalized, setFinalized] = useState(false);
  const [finishActivity] = useMutation(api.game.finishActivity);
  useEffect(() => {
    if (['error', 'success'].includes(saveResult.status)) {
      console.log('Save result status:', saveResult.status);
      if (saveResult.status === 'error') {
        console.error('Error saving game results:', saveResult.error);
      }
      setSaved(true);
      passedGamesCount.refetch({ force: true });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveResult.status, saveResult.error]);

  useEffect(() => {
    // Debug logging
    console.log('GameEnd save conditions:', {
      deviceInfo: !!deviceInfo,
      practiceData: !!practiceData,
      results: !!results,
    });

    // Make location optional - only require deviceInfo, practiceData, and video status
    // Location can be an empty object if consent wasn't given
    if (deviceInfo && practiceData !== undefined) {
      console.log('Saving game results...');
      saveResults({
        results,
        device: deviceInfo,
        practiceData: practiceData || [],
      });
    } else {
      console.log('Waiting for required data to save...');
    }
  }, [deviceInfo, practiceData, results, saveResults]);

  const load = () => {
    const game = {
      browserName,
      browserVersion,
      osVersion,
      osName,
      browserLanguage: navigator.language,
    };

    setDeviceInfo(game);
  };

  useEffect(() => {
    load();
  }, []);

  // Location capture removed for participant flow.

  // Add timeout fallback - if save takes too long, show error
  useEffect(() => {
    if (saved) return; // Don't set timeout if already saved
    
    const timeout = setTimeout(() => {
      if (!saved) {
        console.warn('Save operation taking too long (60s), forcing save state to allow user to proceed');
        setSaved(true);
      }
    }, 60000); // 60 second timeout

    return () => clearTimeout(timeout);
  }, [saved]);

  if (!saved || passedGamesCount.status === 'loading') {
    const errorMessage = saveResult.status === 'error' 
      ? 'There was an error saving your results. Please try again or contact support.'
      : 'Thank you for completing the test. Please wait while we save your results, do not close or refresh this page. This might take up to 30 seconds...';
    return <Loader text={errorMessage} image={Logo} />;
  }

  if (finalized) {
    return (
      <StyledPage
        theme={{ gameColor: gameConfig.gameColor }}
        className="game-main-page full-height"
      >
        <div className="instructions-container instructions-container--start">
          <div className="game-finished-container">
          <div className="game-results-text">
            <p className="title">Thank you! Your activity has been completed.</p>
          </div>
        </div>
        </div>
      </StyledPage>
    );
  }

  return (
    <StyledPage
      theme={{ gameColor: gameConfig.gameColor }}
      className="game-main-page full-height"
    >
      <div className="instructions-container instructions-container--start">
        <div className="game-finished-container">
          <div className="game-results-text">
            <p className="title">
              Congratulations! You completed the brain health activity.
            </p>
            {/* Results visualization removed for participant flow */}
          </div>
        </div>
        <div
          className="instructions-buttons"
          style={{ justifyContent: 'center', gap: '1rem' }}
        >
          {passedGamesCount.data.data.count === 1 && (
            <div
              className="instruction-button instruction-button--green"
              onClick={resetTest}
            >
              Repeat Test
            </div>
          )}
          <button
            type="button"
            className="instruction-button instruction-button--purple"
            onClick={async () => {
              await finishActivity();
              localStorage.setItem('niji-finalized', 'true');
              setFinalized(true);
            }}
          >
            Finish Activity
          </button>
        </div>
      </div>

    </StyledPage>
  );
};

export default GameEnd;
